import liveswitch from "fm.liveswitch";

/**
 * Fully releases camera/mic: stop LiveSwitch LocalMedia and force-stop
 * any underlying MediaStreamTrack still held by the preview <video>.
 */
export function releaseLocalMedia(localMedia?: liveswitch.LocalMedia | null): void {
    if (!localMedia) return;

    // Force-stop browser tracks first so the OS camera light turns off even if
    // LiveSwitch stop() is slow or rejects.
    try {
        const view = localMedia.getView?.() as HTMLElement | undefined;
        const videos = view
            ? Array.from(view.querySelectorAll("video"))
            : [];
        for (const video of videos) {
            const stream = video.srcObject as MediaStream | null;
            if (stream) {
                stream.getTracks().forEach((t) => {
                    try {
                        t.stop();
                    } catch {}
                });
                video.srcObject = null;
            }
        }
    } catch {}

    try {
        const tracks = [
            ...(localMedia.getAudioTracks?.() || []),
            ...(localMedia.getVideoTracks?.() || []),
        ];
        for (const track of tracks) {
            try {
                // LiveSwitch tracks may expose an underlying MediaStreamTrack
                const raw =
                    (track as any)?.getMediaStreamTrack?.() ||
                    (track as any)?.getTrack?.() ||
                    (track as any)?._mediaStreamTrack;
                raw?.stop?.();
            } catch {}
        }
    } catch {}

    try {
        const state = localMedia.getState?.();
        const alreadyStopped =
            state === liveswitch.LocalMediaState.Stopped ||
            state === liveswitch.LocalMediaState.New;

        const finish = () => {
            try {
                localMedia.destroy();
            } catch {}
        };

        if (alreadyStopped) {
            finish();
            return;
        }

        const future = localMedia.stop();
        if (future?.then) {
            future.then(finish).fail(finish);
        } else {
            finish();
        }
    } catch {
        try {
            localMedia.destroy();
        } catch {}
    }
}
